module.exports = __webpack_public_path__ + "media/images/admin/dashboard-links-b935c609e34a04b566c9b585c217fb13.jpg";